
<div class="notes-sheet">
  <h2>Note</h2>
  <textarea class="notes-sheet__body" *ngIf="!data.viewMode" [ngModel]="data.value" (ngModelChange)="onChange($event)"></textarea>
  <p class="notes-sheet__body" *ngIf="data.viewMode">{{data.value}}</p>
</div>
